import { getAxios } from '@smg-real-estate/hg-networking';

import { type Agency, ListingType, SortingOption } from '@/types';

const axios = getAxios({
  baseURL: `${import.meta.env.VUE_APP_AGENCY_META_API_URL}/`,
  headers: { 'Content-Type': 'application/json' },
});

interface AxiosAgenciesResponse {
  data: {
    from: number;
    size: number;
    total: number;
    records: Agency[];
  };
}

export interface AgencySearchRequest {
  query?: {
    geoLocationId?: string;
  };
  from?: number;
  size?: number;
  geoLocationIds?: string[];
  listingType?: ListingType;
  includeChildren?: boolean;
  sortBy?: SortingOption;
}

export type PaginatedAgenciesResponse = AxiosAgenciesResponse['data'];
export const DEFAULT_AGENCY_PAGE_LIST_SIZE = 20;

export async function fetchAgencies(
  request: AgencySearchRequest,
): Promise<PaginatedAgenciesResponse> {
  const DEFAULT_FROM = 0;
  const data = {
    from: request.from ?? DEFAULT_FROM,
    size: request.size ?? DEFAULT_AGENCY_PAGE_LIST_SIZE,
    location: { geoTags: request.geoLocationIds },
    ...(request.includeChildren ? { includeChildren: request.includeChildren } : {}),
    ...(request.listingType !== ListingType.ANY ? { listingType: request.listingType } : {}),
    ...(request.sortBy !== SortingOption.DEFAULT ? { sortBy: request.sortBy } : {}),
  };

  const response = await axios.post<AxiosAgenciesResponse>('/customers', data);

  return response.data.data;
}
